import React from 'react';
import { Link } from "react-router-dom";

const NatyaFusion = () => {
  return (
    <div className="py-20 px-4 md:px-[192px] bg-white">

      {/* Section Header */}
      <div className='text-center mb-14'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>Adult Women's Class</p>
        <div className='flex items-center justify-center gap-4 mb-4'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
          Natya<span className='text-[#E40F94] italic'>Fusion</span>
        </h1>
        <p className='mt-4 md:text-[18px] text-[16px] text-gray-500 leading-7 max-w-3xl mx-auto'>
          👑 Calling all Bharatanatyam Queens! Have you learned and danced Bharatanatyam in your younger days, and now find yourself as a busy professional or a mom juggling life's many demands? This is your chance to rekindle your passion for dance. 💃
        </p>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      {/* Main Cards */}
      <div className='flex flex-col gap-10 max-w-4xl mx-auto'>

        {/* Join NatyaFusion — Houston Rockets recruiting */}
        <div className='rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#1a0010] via-[#3d0228] to-[#E40F94] text-white'>
          <div className='px-8 md:px-12 py-10 text-center'>
            <p className='text-[12px] uppercase tracking-[5px] font-bold text-pink-200 mb-3'>🏀 Now Recruiting · February 28, 2027 🏀</p>
            <h2 className='font-bold text-[30px] md:text-[40px] leading-tight mb-4' style={{ fontFamily: 'Playfair Display, serif' }}>
              Join NatyaFusion: <em className='text-pink-200'>Perform at a Houston Rockets Game!</em>
            </h2>
            <p className='text-[16px] md:text-[18px] leading-8 text-pink-50 max-w-2xl mx-auto mb-8'>
              Are you a classically trained dancer ready to return to the stage? Join NatyaFusion, Chilanka's adult dance team.
              After our final FIFA Fan Festival performance, we're preparing for the Houston Rockets pregame show on February 28, 2027.
            </p>
            <Link to='/contact?interest=natyafusion' className='inline-block bg-white text-[#E40F94] font-bold text-[15px] px-8 py-4 rounded-full shadow-lg hover:bg-pink-50 transition-colors duration-300'>
              Interested? Fill out our contact form →
            </Link>
            <p className='text-pink-200 text-[13px] mt-4'>We'll be in touch!</p>
          </div>
        </div>

        {/* About NatyaFusion */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Our Story</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>✨ About NatyaFusion</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>
              🎶 The perfect blend of classical technique and modern expression.
            </p>
            <p className='text-gray-600 text-[16px] leading-7'>
              Do you enjoy watching Usha Jey's choreography videos and dream of dancing again with a group of like-minded women? 🌸 Join our NatyaFusion Dance Team and experience the perfect blend of classical technique and modern expression as we embark on a creative journey together.
            </p>
          </div>
        </div>

        {/* Why NatyaFusion */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Benefits</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>🌟 Why NatyaFusion?</h2>
          </div>
          <div className='px-8 py-6'>
            <p className='text-[#E40F94] font-semibold text-[16px] italic mb-4'>
              🤝 A unique opportunity to bring beauty, movement, and community together.
            </p>
            <div className='space-y-3 text-gray-600 text-[16px] leading-7'>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🕺 Blend of classical Bharatanatyam technique with modern choreography.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>👯‍♀️ Join a community of like-minded women passionate about dance.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>⏰ Flexible and accessible to busy professionals and moms.</p>
              </div>
              <div className='flex items-start gap-3'>
                <span className='text-[#E40F94] mt-1'>✦</span>
                <p>🎨 Experience joy and creativity while learning at your own pace.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className='bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden'>
          <div className='bg-[#E40F94] px-8 py-4'>
            <p className='text-white text-[13px] uppercase tracking-[4px] font-semibold'>Get Started</p>
            <h2 className='text-white font-bold text-[28px]' style={{ fontFamily: 'Playfair Display, serif' }}>🔥 Ready to Rekindle Your Dance Passion?</h2>
          </div>
          <div className='px-8 py-6 text-center'>
            <p className='text-gray-600 text-[16px] leading-7 mb-8'>
              💌 Please send us a message via our Contact Us page so we can add you to our list of interested participants. We'd love to have you join our growing dance community! 🌺
            </p>
            <Link to="/contact?interest=natyafusion">
              <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-500 to-pink-500 group-hover:from-purple-500 group-hover:to-pink-500 hover:text-white focus:ring-4 focus:outline-none focus:ring-purple-200">
                <span className="relative px-8 py-3 transition-all ease-in duration-75 bg-white rounded-md group-hover:bg-transparent group-hover:text-white text-[15px] font-semibold">
                  📩 Contact Us
                </span>
              </button>
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default NatyaFusion;